/* ============================================================
   Pomegranate V2 — dedicated script
   All JS for template.pomegranate_v2_premium sections lives here.
   ============================================================ */

$(document).ready(function () {
  function updatePg2Prices($variant) {
    var subPrice = $variant.data("sub-price");
    var otpPrice = $variant.data("otp-price");

    var atcLabel = $(".pg2-atc-btn").data("label") || "Add to cart";
    $(".pg2-atc-btn").text(atcLabel + " · " + subPrice);

    var buyOnceLabel = $(".pg2-buy-once").data("label") || "Buy once - no savings";
    $(".pg2-buy-once").text(buyOnceLabel + " " + otpPrice);

    var subTrust1 = $variant.data("sub-trust-1") || "";
    var subTrust2 = $variant.data("sub-trust-2") || "";
    $(".pg2-sub-trust-text-1").text(subTrust1);
    $(".pg2-sub-trust-item-1").toggleClass("hided", subTrust1 === "");
    $(".pg2-sub-trust-text-2").text(subTrust2);
    $(".pg2-sub-trust-item-2").toggleClass("hided", subTrust2 === "");
  }

  $(".pg2-variant").click(function () {
    $(".pg2-variant").removeClass("active");
    $(this).addClass("active");
    updatePg2Prices($(this));
  });

  var $initialActive = $(".pg2-variant.active").first();
  if ($initialActive.length) {
    updatePg2Prices($initialActive);
  }

  function pg2AddToCart(sellingPlan, $btn) {
    var $active = $(".pg2-variant.active");
    if (!$active.length) return;

    var data = {
      id: $active.data("id"),
      quantity: 1,
      sections: "cell_cart_drawer",
    };
    if (sellingPlan) data.selling_plan = $active.data("selling-plan");

    $btn.attr("aria-disabled", true);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) return;
        if (window.refreshCartDrawer) window.refreshCartDrawer(false);
        if (window.openCartDrawer) window.openCartDrawer(true);
      })
      .catch(function (e) {
        console.error("Add to cart error:", e);
      })
      .finally(function () {
        $btn.removeAttr("aria-disabled");
      });
  }

  $(".pg2-atc-btn").click(function (evt) {
    evt.preventDefault();
    pg2AddToCart(true, $(this));
  });

  $(".pg2-buy-once").click(function (evt) {
    evt.preventDefault();
    pg2AddToCart(false, $(this));
  });

  var $pg2ReviewsSlider = $(".pg2-reviews-slider");
  if ($pg2ReviewsSlider.length) {
    $pg2ReviewsSlider.slick({
      centerMode: true,
      centerPadding: "60px",
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            centerPadding: "12.5%",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: "30px",
          },
        },
      ],
    });

    $(".pg2-reviews-prev").click(function () {
      $pg2ReviewsSlider.slick("slickPrev");
    });

    $(".pg2-reviews-next").click(function () {
      $pg2ReviewsSlider.slick("slickNext");
    });
  }

  $(".pg2-faq-item").click(function () {
    $(this).toggleClass("active");
    $(this).find(".pg2-faq-content").slideToggle();
  });

  $(".pg2-verified").each(function () {
    var $section = $(this);
    var $items = $section.find(".pg2-verified-item");
    var $more = $section.find(".pg2-verified-more");
    var $less = $section.find(".pg2-verified-less");
    var step = parseInt($section.data("step"), 10) || 3;
    var visible = step;

    function pg2RenderVerified() {
      $items.each(function (i) {
        $(this).toggleClass("hided", i >= visible);
      });
      $more.toggleClass("hided", visible >= $items.length);
      $less.toggleClass("hided", visible <= step);
    }

    pg2RenderVerified();

    $more.click(function () {
      visible += step;
      pg2RenderVerified();
    });

    $less.click(function () {
      visible = step;
      pg2RenderVerified();
    });
  });
});
